// extracted by mini-css-extract-plugin
export var menuItem = "T_yj d_fZ d_bz d_bD d_bP d_bf";
export var menuItemSub = "T_yk d_Z d_bz d_bP";
export var menuMainLink = "T_yl d_f0 d_dB";
export var menuLink = "T_ym d_f0 d_dB";
export var icon = "T_n7 d_bC d_bP";
export var divider = "T_yn d_bC d_bP";
export var sublinks = "T_yp";
export var link = "T_mZ";
export var Link = "T_wv K_wv K_vQ K_v8";